// Legacy flat keys still referenced by old i18n.t() calls. Machine-drafted — review before launch.
const legacyAr: Record<string, string> = {
	addteamMemberbtn: 'إضافة عضو للفريق',
	appsumo_code: 'رمز AppSumo',
	card_delivered: 'تم تسليم هذه البطاقة بالفعل.',
	cards: 'البطاقات',
	change_pass: 'تغيير كلمة المرور',
	confirm_pass: 'تأكيد كلمة المرور الجديدة',
	create_new_card: 'إنشاء بطاقة',
	draft: 'مسودة',
	email: 'البريد الإلكتروني',
	enter_appsumo_code: 'أدخل رمز AppSumo',
	enter_email_address: 'أدخل بريدك الإلكتروني',
	firstName: 'الاسم الأول',
	generate_card_preview: 'يرجى الانتظار بينما نُنشئ معاينة البطاقة',
	lastName: 'اسم العائلة',
	login: 'سجّل الدخول إلى حسابك',
	logout: 'تسجيل الخروج',
	my: 'بطاقاتي',
	new_pass: 'كلمة مرور جديدة',
	not_a_valid_file: 'ملف غير صالح.',
	page_not_found_header: 'الصفحة التي تبحث عنها غير موجودة',
	page_not_found_para: 'إمّا أنك حاولت الوصول عبر رابط خاطئ أو وصلت إلى هنا عن طريق الخطأ. في كلتا الحالتين، استخدم قائمة التنقل.',
	pricing: 'الأسعار',
	register: 'إنشاء حساب',
	savebtn: 'حفظ',
	scheduled: 'مجدول',
	select_from_collection: 'اختر من المجموعة',
	updatebtn: 'تحديث الملف الشخصي',
	updateteamMemberbtn: 'تحديث',
	upload_image: 'رفع صورة',
	your_email_address: 'البريد الإلكتروني',
	checkout_desc_1: 'اختر أحد التصاميم المرسومة من فنانينا كغلاف، أو أنشئ تصميمك الخاص',
	checkout_desc_2: 'صمّم بطاقتك بمجموعة من الخطوط والألوان وأنماط النصوص، وارفع صورك الخاصة.',
	checkout_desc_3: 'تتيح لك ميزة المشاركة البسيطة دعوة كل من يرغب في المشاركة بكتابة تحية',
	checkout_desc_4: 'اختر تاريخ هذا التسليم الخاص للإرسال التلقائي.',
	checkout_heading_1: 'اختر تصاميم مرسومة',
	checkout_heading_2: 'صمّم ووقّع',
	checkout_heading_3: 'تعاون وشارك',
	checkout_heading_4: 'تسليم تلقائي مجدول',
};
export default legacyAr;
